import { VendorService } from '@controlling/proxy/controlling/controllers';
import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const VENDORDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('country', 'Entity.VendorDetail.Country')
    .maxLength(3)
    .build(),
  FieldBuilder
    .text('state', 'Entity.VendorDetail.State')
    .maxLength(25)
    .build(),
  FieldBuilder
    .text('city', 'Entity.VendorDetail.City')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('street', 'Entity.VendorDetail.Street')
    .maxLength(255)
    .build(),
  FieldBuilder
    .text('houseNumber', 'Entity.VendorDetail.DoorNumber')
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('postCode', 'Entity.VendorDetail.PostCode')
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('telephoneNumber', 'Entity.VendorDetail.TelephoneNumber')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('cellphoneNumber', 'Entity.VendorDetail.CellphoneNumber')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('faxNumber', 'Entity.VendorDetail.FaxNumber')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('email', 'Entity.VendorDetail.Email')
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .hideInChildForms()
    .build(),
];

export const VENDORDETAIL_CONFIG = {
  entityName: 'VendorDetail',
  localizationKey: 'Controlling::Entity.VendorDetail',
  fields: VENDORDETAIL_FIELDS,
  permission: 'ControllingContract.VendorDetails',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
